import { z } from "@/zod";

import {
  rate,
  storeId,
  projectId,
  roleId,
  settlementType,
  dateTime,
} from "@/schemas/commonFields";
import { removeNullishFields } from "@/lib/utils/zod";

export const roleBasedProjectRates = z.object({
  id: z.string(),
  project_id: projectId,
  project_name: z.string(),
  store_id: storeId.nullable().optional(),
  store_name: z.string().optional(),
  project_role_id: roleId.nullable().optional(),
  project_role_name: z.string().optional(),
  valid_from: z.string(),
  settlement_type: z.union([settlementType, z.literal("")]),
  description: z.string().nullable().optional(),
  created_at: dateTime,
  updated_at: dateTime,
  ...rate.shape,
});

export type RoleBasedProjectRates = z.infer<typeof roleBasedProjectRates>;

export const readRoleBasedProjectRates = roleBasedProjectRates
  .omit({
    project_name: true,
    updated_at: true,
    created_at: true,
  })
  .readonly();

export type ReadRoleBasedProjectRates = z.infer<
  typeof readRoleBasedProjectRates
>;

export const writeRoleBasedProjectRatesBase = roleBasedProjectRates.omit({
  id: true,
  store_name: true,
  project_role_name: true,
  project_name: true,
  created_at: true,
  updated_at: true,
});

export const writeRoleBasedProjectRates = removeNullishFields(
  writeRoleBasedProjectRatesBase,
);

export type WriteRoleBasedProjectRates = z.infer<
  typeof writeRoleBasedProjectRates
>;
